import {
  formatDateParam,
  makeRequest,
  makeConcurrentRequest,
} from "../lib/makeRequest";
import moment from "moment";

export const profit_breakdown_overall = (data) =>
  makeRequest("/profit-breakdowns/overall", {
    covered_date: formatDateParam(data.covered_date),
  });

export const profit_breakdown_cluster = (data) =>
  makeRequest(`/profit-breakdowns/cluster/${data.clusterId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const profit_breakdown_area = (data) =>
  makeRequest(`/profit-breakdowns/area/${data.area_code}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const profit_breakdown_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "covered_date",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/profit-breakdowns/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const profit_breakdown_branch_concurrent_request = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("covered_date", formatDateParam(data.covered_date));

  const requestData = data.branchCodechunks.map((chunk) => {
    return {
      endpoint: `/profit-breakdowns/branches?${urlParams.toString()}`,
      params: chunk,
    };
  });

  return makeConcurrentRequest(requestData, "post");
};
